import './cursorPagination.scss';
import {Cursor} from "../../../utils/models/Page";
import {IPromise, IScope} from "angular";
import {Identifiable} from "../../../opportunities/model/Opportunity";

export interface CursorPaginationScope<T extends Identifiable> extends IScope {
    fetchLog: (nextCursor?: number, beforeCursor?: number) => IPromise<T[]>;
    next: () => void;
    before: () => void;
    changeSize: () => void;
    pagingConfig: Cursor<T>;
    pageSizes: number[];
    isDisabledBefore: boolean;
}

export class CursorPagination<T extends Identifiable> {
    static instance = {
        controller: [
            '$scope',
            CursorPagination
        ],
        template: require('./cursorPagination.html'),
        bindings: {
            pagingConfig: '<',
            items: '<',
            fetchLogs: '<'}
    };

    private items: T[];
    private $scope: CursorPaginationScope<T>;
    private pagingConfig: Cursor<T>;
    private fetchLogs: (nextCursor?: number, beforeCursor?: number) => IPromise<T[]>;


    constructor($scope: CursorPaginationScope<T>) {
        this.$scope = $scope;
    }

    $onInit = () => {
        let $scope = this.$scope;
        $scope.isDisabledBefore = true;
        $scope.pageSizes = [10,20,50,100];
        $scope.fetchLog = this.fetchLogs;
        $scope.next = this.next;
        $scope.before = this.before;
        $scope.changeSize = this.changeSize;
        $scope.pagingConfig = this.pagingConfig;
    };


    before = () => {
        let cursor = this.items[0].id + 1;
        let promise = this.fetchLogs(null, cursor);
        promise.then((data) => {
            this.checkAccessResponse(data, null, cursor);
        });
    }

    changeSize = () => {
        let promise = this.fetchLogs(this.items[0].id, null);
        promise.then((data) => {
            this.checkAccessResponse(data, this.items[0].id, null, true);
        });
    }

    next = () => {
        let  cursor = this.items[this.items.length - 1].id - 1;
        let promise = this.fetchLogs(cursor, null);
        promise.then((data) => {
            this.checkAccessResponse(data, cursor);
        });
    };

    checkAccessResponse = (data: T[], nextCursor?: number, beforeCursor?: number, isSizeChanged?: boolean) => {
        if (data.length > this.$scope.pagingConfig.pageSize) {
            if (nextCursor != null && !isSizeChanged) {
                this.$scope.pagingConfig.hasNext = true;
                this.$scope.pagingConfig.hasBefore = true;
                data.pop();
            } else if (beforeCursor != null && !isSizeChanged) {
                this.$scope.pagingConfig.hasBefore = true;
                this.$scope.pagingConfig.hasNext = true;
                data.shift();
            } else if (nextCursor != null && isSizeChanged) {
                data.pop();
            }
        } else if ((nextCursor == null) && (beforeCursor == null)) {
            this.$scope.pagingConfig.hasNext = false;
            this.$scope.pagingConfig.hasBefore = false;
        } else if (nextCursor != null) {
            this.$scope.pagingConfig.hasBefore = true;
            this.$scope.pagingConfig.hasNext = false;
        } else if (beforeCursor != null) {
            this.$scope.pagingConfig.hasBefore = false;
            this.$scope.pagingConfig.hasNext = true;
        }
    };
}
